import type { Patient, Reference } from '@medplum/fhirtypes'
import { PatientFlag } from '@seen/core/models/flags/patientFlag'
import type { UseQueryResult } from '@tanstack/react-query'
import { useSearch } from '#src/hooks/useSearch.ts'

// Active OOSA / Critical Attention / Isolation Required Flags for the
// facesheet badge. History
// (inactive Flags) stays on PatientFlag.byOosa and only runs when a modal is
// open. Same query key as CurrentParticipantProvider so a refresh starts this
// search in parallel with the Patient read.
export function useParticipantModalFlags(
  patient: Reference<Patient> | undefined
): UseQueryResult<PatientFlag[]> {
  return useSearch(
    PatientFlag,
    patient ? PatientFlag.byParticipant(patient) : undefined
  )
}
